var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prompt"},[_c('img',{attrs:{"src":require("../../assets/images/newicon/nodata.png")}}),_c('div',{staticClass:"nodata"},[_vm._v("童鞋，暂时木有内容哟~")])])
}]

export { render, staticRenderFns }